import React from 'react';
import PropTypes from 'prop-types';
import { Grid } from '@mui/material';
import { ExpensesByCategoryPieChart } from '../ExpensesByCategoryPieChart';
import { IncomesByCategoryPieChart } from '../IncomesByCategoryPieChart';

export function CategoriesTab({ period }) {
  return (
    <Grid container spacing={3}>
      <Grid size={{ xs: 12, md: 6 }} display="flex" justifyContent="center">
        <ExpensesByCategoryPieChart {...period} />
      </Grid>

      <Grid size={{ xs: 12, md: 6 }} display="flex" justifyContent="center">
        <IncomesByCategoryPieChart {...period} />
      </Grid>
    </Grid>
  );
}

CategoriesTab.propTypes = {
  period: PropTypes.shape({
    selectedDate: PropTypes.object.isRequired,
    viewByYear: PropTypes.bool.isRequired,
    viewAllPeriod: PropTypes.bool.isRequired,
  }).isRequired,
};
